// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  environmentLabel: 'local',
  environmentLabelVisible: true,
  idleTimeoutInMinutes: 12 * 60,
  agGridLicenseKey: '',
  okta: true,
  oktaDomain: 'https://login.qa.tecalliance.cloud',
  oktaClientId: '0oaa24kthj8ujiLzD0x7',

  services: {
    baseUri: 'https://vdp.test.analytics.tecalliance.cloud',
    vdpApi: 'https://api-vdp.test.analytics.tecalliance.cloud/api',
  },
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
